module.exports = __webpack_public_path__ + "img/BG.77d14b92.svg";